import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmButton } from '../buttons/ConfirmButton';
import { reveal } from '../keyframe-animations';

interface ReportCompleteProps {
  onConfirmClick: () => void;
}

export const ReportComplete: React.FC<ReportCompleteProps> = ({ onConfirmClick }) => {
  const { t } = useTranslation('translation');
  return (
    <div
      className={css`
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        height: 100%;
        .desc,
        .confirm {
          opacity: 0;
          visibility: hidden;
          transform: translateY(-10px);
          animation: 0.3s ease-out ${reveal} both;
        }
        .desc {
          flex: 1 1 auto;
          padding: 12px 0;
        }
        .confirm {
          width: 100%;
          margin: 20px 0 8px;
        }
        @media (max-width: 369px) {
          .desc {
            font-size: 14px;
          }
        }
      `}
    >
      <p className="desc">{t('report_spam_complete')}</p>
      <div className="confirm">
        <ConfirmButton onClick={onConfirmClick}>{t('dialog_button_ok')}</ConfirmButton>
      </div>
    </div>
  );
};
